// Compare list persisted to localStorage. Capped at MAX_COMPARE entries.
const KEY = 'itec_compare';
export const MAX_COMPARE = 4;
export const COMPARE_EVENT = 'compare:changed';

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent(COMPARE_EVENT));
  } catch {
    // ignore
  }
}

export function getCompareList() {
  return read();
}

export function isInCompare(productId) {
  return read().some((p) => p.id === productId);
}

export function addToCompare(product) {
  if (!product?.id) return { list: read(), added: false, reason: 'invalid' };
  const list = read();
  if (list.some((p) => p.id === product.id)) {
    return { list, added: false, reason: 'duplicate' };
  }
  if (list.length >= MAX_COMPARE) {
    return { list, added: false, reason: 'full' };
  }
  const next = [
    ...list,
    {
      id: product.id,
      slug: product.slug,
      name: product.name,
      mainImage: product.image || product.main_image_url || null,
      brand: product.brand_name || product.brand?.name || null,
      priceVisibility: product.price_visibility || null,
      regularPrice: product.regular_price ?? null,
      salePrice: product.sale_price ?? null,
    },
  ];
  write(next);
  return { list: next, added: true };
}

export function removeFromCompare(productId) {
  const next = read().filter((p) => p.id !== productId);
  write(next);
  return next;
}

export function clearCompare() {
  write([]);
}
